import styled from "styled-components";

export const Header = styled.header`
  background: #0DB14B;
  padding: 30px 5% 10px 5%;
`;

export const ActionsContainer = styled.div`
  background: #FFF;
  padding: 10px 5%;
`;

export const Container = styled.div`
  margin: 30px 5%;
  padding: 15px;
  border-radius: 5px;
  background: #FFF;
`;
